import {Document} from "../../src/interfaces/interfaces";

const uzitecneDokumenty: Document[] = [
    {
        title: 'Normy náčiní',
        document: 'nacini.pdf'
    },
    {
        title: 'Rozvrh jaro 2025',
        document: 'rozvrh jaro 2025.pdf'
    },
    {
        title: 'Provozní řád domečku 2025',
        document: 'provozní řád domeček 2025 podepsaný.pdf'
    },
    {
        title: 'Prohlídka od pediatra',
        document: 'zpusobilost_sport.pdf'
    },

]

export default uzitecneDokumenty
